<template>
    <div 
                class="modal show" 
                id="alertModificada" 
                tabindex="-1" 
                aria-labelledby="policies-modal" 
                aria-hidden="true">
                  <div class="modal-dialog modal-xl">
                    <div class="modal-content rounded-0">
                      <div 
                      class="modal-header rounded-0" 
                      style="background-color:#169a5a;">
                        <h5 class="modaltitle" id="policies-modal">{{$t('modify.mod26')}}</h5>
                        <button  type="button" @click="salir" class="close text-white">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <b-row>
                          <b-col md="12">
                            <h3 class="tittleModal"></h3>
                            <hr>
                            <p>{{$t('modify.mod27')}}</p>
                            <br>
                            
                            <button 
                                    class="btn btn-secondary float-right mr-2" 
                                    style="border-radius:0px;" 
                                    @click="salir">
                                    Ok
                            </button>
                          </b-col>   
                          </b-row>
                      </div>
                    </div>
                  </div>
                </div>
</template>

<script>
import { mapMutations } from 'vuex'
    export default {
        methods: {
          ...mapMutations('reservav2', ['MT_VALORESPORDEFECTO']),
            salir() {
                this.MT_VALORESPORDEFECTO()
                location.replace('/')
            }
        },
    }
</script>

<style lang="scss" scoped>
.borderdiv{
  border-radius: 0px;
  border: solid 2px #b8b8b8;
}
.modaltitle{
    color: white;
}
hr{
  height: 5%;
}
.input-sucursal{
  border: none; 
  height: 60px; 
  padding-left: 15px; 
  padding-right: 15px; 
  font-size: 20px; 
  width: 99%;
  background: url("/img/flecha.png") no-repeat right/1.4% ;
  background-color: rgb(255, 255, 255);
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}
</style>